import React, { memo } from 'react';

const PhoneIcon = (props) => (
    <svg
        width="40"
        height="38"
        viewBox="0 0 40 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g filter="url(#filter0_d_1141_2210)">
            <path
                d="M25 10.5H15C12 10.5 10 12 10 15.5V22.5C10 26 12 27.5 15 27.5H25C28 27.5 30 26 30 22.5V15.5C30 12 28 10.5 25 10.5ZM25.47 16.59L22.34 19.09C21.68 19.62 20.84 19.88 20 19.88C19.16 19.88 18.31 19.62 17.66 19.09L14.53 16.59C14.21 16.33 14.16 15.85 14.41 15.53C14.67 15.21 15.14 15.15 15.46 15.41L18.59 17.91C19.35 18.52 20.64 18.52 21.4 17.91L24.53 15.41C24.85 15.15 25.33 15.2 25.58 15.53C25.84 15.85 25.79 16.33 25.47 16.59Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_1141_2210"
                x="0"
                y="0.5"
                width="40"
                height="37"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
                <feFlood
                    floodOpacity="0"
                    result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                <feOffset />
                <feGaussianBlur stdDeviation="5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.92549 0 0 0 0 0 0 0 0 0 0.545098 0 0 0 0.06 0" />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1141_2210" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1141_2210"
                    result="shape" />
            </filter>
        </defs>
    </svg>

);

export default memo(PhoneIcon);
